import {
  UPDATE_USER_ID,
  UPDATE_USER_PHONE,
  UPDATE_USER_AVATAR,
  SET_USER_TOKEN,
  UPDATE_USER_NICKNAME,
  UPDATE_USER_BASE_INFO
} from '../mutation-types'
import superagent from 'superagent'
import Address from './address'
import Config from './config'
import UserInfo from './userInfo'
import { RequestCommonResponse } from '../actions'
const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL

const state = {
  user_id: null,
  user_phone: null,
  user_avatar: null,
  user_nickname: null,
  user_base_info: {}
}

const mutations = {
  [UPDATE_USER_NICKNAME] (state, nickname) {
    state.user_nickname = nickname
  },
  [UPDATE_USER_ID] (state, user_id) {
    state.user_id = user_id
  },
  [UPDATE_USER_PHONE] (state, user_phone) {
    state.user_phone = user_phone
  },
  [UPDATE_USER_AVATAR] (state, user_avatar) {
    state.user_avatar = user_avatar
  },
  [SET_USER_TOKEN] (state, token) {
    state.token = token
  },
  [UPDATE_USER_BASE_INFO] (context, data) {
    state.user_base_info = data
  }
}

const actions = {
  // 设置用户信息
  setUserInfo ({ commit }, params) {
    commit('UPDATE_USER_ID', params.user_id ? params.user_id : '')
    commit('UPDATE_USER_PHONE', params.mobile ? params.mobile : '')
    commit('SET_USER_TOKEN', params.token ? params.token : '')
  },
  // 获取验证码
  getCode ({ commit, state, rootState }, params) {
    if (Config.state.enterprise_id) {
      params.enterprise_id = Config.state.enterprise_id
    }
    if (params) {
      params.channel = '2'
    }
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/sms/code/send_new')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  // 用户登入
  userLogin ({ commit, state, rootState }, params) {
    if (Config.state.enterprise_id) {
      params.enterprise_id = Config.state.enterprise_id
    }
    if (UserInfo.state.user_id) {
      params.user_id = UserInfo.state.user_id
    }
    if (params) {
      params.login_type = '1'
    }
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/users/login/login_new')
      .set('Accept', 'application/json')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  // 用户登出
  userLogout ({ commit, state, rootState }, params) {
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/users/mine/login_out')
      .set('Accept', 'application/json')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  // 自动登入
  autoLogin ({ commit, state, rootState }) {
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/users/mine/auto_login')
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              // if (res.data.login) {
              commit(UPDATE_USER_ID, res.data.ltb_user_id)
              commit(UPDATE_USER_PHONE, res.data.user_name)
              commit(UPDATE_USER_AVATAR, res.data.user_head_img)
              commit(UPDATE_USER_NICKNAME, res.data.user_nick)
              // }
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  getUserInfo (context, callback) {
    // 已请求过
    if (state.user_base_info.ltb_user_id) {
      if (callback) {
        callback(true)
      }
      return
    }
    superagent
    .post(baseUrl + '/index.php/api/v1/getUserInfo')
    .send({
      key: JSON.stringify({
        userID: state.user_id
      })
    })
    .type('form')
    .end(function (err, res) {
      if (err) throw err
      let _data = JSON.parse(res.text)
      if (_data.result === '1') {
        context.commit('UPDATE_USER_BASE_INFO', _data.data)
        if (_data.data.company_place) {
          context.commit('UPDATE_LOCATION', {
            from: 'company',
            location: {
              address_title: _data.data.company_place,
              point: {
                lat: _data.data.company_lat,
                lng: _data.data.company_lng
              }
            }
          }, {root: true})
        }
        if (_data.data.company_place) {
          context.commit('UPDATE_LOCATION', {
            from: 'home',
            location: {
              address_title: _data.data.home_place,
              point: {
                lat: _data.data.company_lat,
                lng: _data.data.company_lng
              }
            }
          }, {root: true})
        }
        if (callback) {
          callback(true)
        }
      } else {
        if (callback) {
          callback(false)
        }
        // window.alert(res.info)
      }
    })
  },
  saveUserInfo ({ commit }, params) {
    return new Promise(function (resolve, reject) {
      params.company = Address.state.location.company.address_title
      params.compLng = Address.state.location.company.point.lng
      params.companyLat = Address.state.location.company.point.lat
      params.home = Address.state.location.home.address_title
      params.homeLng = Address.state.location.home.point.lng
      params.homeLat = Address.state.location.home.point.lat
      params.userID = state.user_id
      if (Config.state.enterprise_id) {
        params.enterprise_id = Config.state.enterprise_id
      }
      superagent
      .post(baseUrl + '/index.php/api/v1/updateUserInfo')
      .send({
        key: JSON.stringify(params)
      })
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _data = JSON.parse(res.text)
        if (_data.result === '1') {
          resolve(_data.info)
        } else {
          reject(_data.info)
        }
      })
    })
  }
}

export default {
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js